import { ROUTES } from "./routes/routes";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProjectProgress from "./components/project/ProjectProgress";
import Header from "./components/header/Header";
import LoginPage from "./pages/LoginPage";
import RequireAuth from "./components/requireAuth/RequireAuth";
import InitializeAuth from "./components/initializeAuth/InitializeAuth";
import UserProjectAccessPage from "./pages/UserProjectAccessPage";
import RedirectPage from "./pages/RedirectPage";

function App() {
  return (
    <InitializeAuth>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path={ROUTES.LOGIN} element={<LoginPage />} />

          <Route
            path={ROUTES.HOME}
            element={
              <RequireAuth>
                <ProjectProgress />
              </RequireAuth>
            }
          />
          <Route
            path={ROUTES.HOME_WITH_PARAMS}
            element={
              <RequireAuth>
                <ProjectProgress />
              </RequireAuth>
            }
          />
          <Route
            path={ROUTES.AUTHORIZE_REDIRECT}
            element={<RedirectPage />}
          />
          <Route
            path={ROUTES.USER_PROJECT_ACCESSES}
            element={
              <RequireAuth roles={"Admin"}>
                <UserProjectAccessPage />
              </RequireAuth>
            }
          />
        </Routes>
      </BrowserRouter>
    </InitializeAuth>
  );
}

export default App;
